<div class="container" *ngLet="files$ | async">
  <div class="title">
    <span class="h3">{{ 'OTHER.DYNAMIC_MODAL_WINDOW_HIDER' | translate }}</span>
    <button class="btn-empty" (click)="close()">
      <svg [icon]="icons.Close" class="close-icon dark-gray-color svg24" />
    </button>
  </div>

  <div class="body">
    <app-search-input (startSearch)="searchStart($event)" [hideGlobalSearchLink]="true" class="mt16"></app-search-input>
    <div class="table-container mt8">
      <div>
        <table mat-table [dataSource]="dataSource" class="table">
          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <p class="body-2">
                <span (click)="!element.loadingFile ? downloadFile(element) : ''" class="file-name">
                  <svg
                    *ngIf="element.loadingFile"
                    [icon]="icons.Loading"
                    [matTooltip]="'OTHER.UPLOAD_FILE' | translate"
                    class="svg24 mr12 dark-gray-color loading-icon"
                  />
                  <svg
                    *ngIf="!element.loadingFile"
                    [icon]="icons.Downloaded"
                    [matTooltip]="'OTHER.DOWNLOAD' | translate"
                    class="svg24 mr12 dark-gray-color"
                  />
                  <span [matTooltip]="'OTHER.DYNAMIC_HISTORY_FILE_TOOLTIP' | translate">{{
                    element.fileTitle + ' (' + element.fileSize + ' ' + ('OTHER.MB' | translate) + ')'
                  }}</span>
                </span>
              </p>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    <app-mat-pagination-custom [allCount]="allCount" (pageEvent)="changePage()"></app-mat-pagination-custom>
  </div>
</div>
